import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=253fe90b&scoped=true"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"
import style0 from "./Area.vue?vue&type=style&index=0&id=253fe90b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253fe90b",
  null
  
)

export default component.exports